<template>
  <v-dialog v-model="dialog" :max-width="loading ? '400px' : '90%'">
    <v-card v-if="loading">
      <v-card-text class="text-center pa-5">
        <v-progress-circular
          class="mr-2"
          size="24"
          width="3"
          indeterminate
          color="primary"
        ></v-progress-circular>
        Buscando informações
      </v-card-text>
    </v-card>
    <v-card v-else-if="openedTicket">
      <v-card-title>
        <div class="row align-center pa-0">
          <div class="col headline">
            {{ ticketInfo.name }}
          </div>
          <div class="col-auto pa-sm">
            <v-btn fab text color="default" @click="dialog = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </div>
        </div>
      </v-card-title>
      <v-divider />
      <div class="row flex-sm-row-reverse ma-0">
        <v-col cols="12" md="4" style="border-left: 1px solid #dedede">
          <v-card-text class="pb-0">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-chip v-on="on" class="mb-3" @click="copyToClipboard(ticketInfo.permalink_url)">
                  Id: <b>{{ ticketInfo.gid }}</b> <v-icon size="15px" class="ml-2">mdi-content-copy</v-icon>
                </v-chip>
              </template>
              <span>Clique para copiar link para o Asana</span>
            </v-tooltip>
            <br />
            <v-chip
              v-for="membership in ticketInfo.memberships"
              :key="membership.project.gid"
              outlined label class="mr-1 mb-1 pr-0"
              :color="ticketStatusColor(membership.section.name)"
            >
              {{ membership.project.name }}
              <v-chip class="ml-2" label :color="ticketStatusColor(membership.section.name)">{{ membership.section.name }}</v-chip>
            </v-chip>
          </v-card-text>
          <v-card-text>
            Última atualização: {{ ticketInfo.modified_at | moment('DD/MM/YYYY HH:mm') }}
            <br />
            Criado em: {{ ticketInfo.created_at | moment('DD/MM/YYYY HH:mm') }}
          </v-card-text>
          <v-card-text>
            <div class="title mb-2">Atendimento Heppi</div>
            <p>
              Responsável: {{ assignee }}
              <br>
              Colaboradores: {{ followers }}
              <v-chip class="mr-1 mt-1" v-for="label in ticketInfo.labels" :key="label.name">{{ label.name }}</v-chip>
            </p>
          </v-card-text>
          <v-card-text>
            <div class="title mb-2">Arquivos</div>
            <a v-for="file in files" :href="file.download_url" target="_blank" :key="file.gid" class="display-block ma-0 mb-2 row align-center blue-grey lighten-5 rounded-md cursor-pointer caption">
              <div class="col-auto">
                <v-icon size="18px">mdi-paperclip</v-icon>
              </div>
              <div class="col">{{ file.name }}</div>
            </a>
          </v-card-text>
        </v-col>
        <v-col cols="12" md="8">
          <v-card-text class="pb-0">
            <p style="white-space: pre-line" v-html="ajustText(ticketInfo.notes)"></p>
          </v-card-text>
          <v-tabs
            v-model="tab"
            center-active
          >
            <v-tabs-slider></v-tabs-slider>
            <v-tab key="tab-comments" href="#tab-comments">Comentários</v-tab>
            <v-tab key="tab-history" href="#tab-history">Histórico</v-tab>
            <v-tab-item key="tab-comments" value="tab-comments" class="py-3">
              <v-card-text class="pb-0 pt-0" v-for="(comment, index) in comments" :key="comment.gid">
                <div v-if="index > 0" class="my-2">---</div>
                <div class="my-2">
                  <div class="caption grey--text">{{ comment.created_at | moment('DD/MM/YYYY hh:mm:ss') }}</div>
                  <div><b>{{ comment.created_by && comment.created_by.name || 'Asana' }}</b></div>
                  <div style="white-space: pre-line" v-html="ajustText(comment.text)" />
                </div>
              </v-card-text>
            </v-tab-item>
            <v-tab-item key="tab-history" value="tab-history" class="pt-0 pb-3">
              <v-card-text>
                <div class="pb-0 pt-2" v-for="change in history" :key="change.gid">
                  <div class="caption grey--text">{{ change.created_at | moment('DD/MM/YYYY hh:mm:ss') }}</div>
                  <div>{{ change.text }}</div>
                </div>
              </v-card-text>
            </v-tab-item>
          </v-tabs>
        </v-col>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'

export default {
  name: 'supportRequestDialog',
  props: ['openedTicket'],
  data () {
    return {
      dialog: false,
      loading: false,
      ticketInfo: {},
      tab: 'tab-comments',
      history: [],
      files: []
    }
  },
  computed: {
    ...mapGetters(['userEmail']),
    assignee () {
      if (this.ticketInfo.assignee && this.ticketInfo.assignee.name) {
        const nameSplit = this.ticketInfo.assignee.name.split(' ')
        return nameSplit[0] + ' ' + nameSplit[1]
      }
      return '-'
    },
    followers () {
      if (this.ticketInfo.followers && this.ticketInfo.followers.length > 0) {
        const followers = this.ticketInfo.followers.map(f => {
          const nameSplit = f.name.split(' ')
          return nameSplit[0] + ' ' + nameSplit[1]
        })
        return followers.join(', ')
      }
      return '-'
    },
    comments () {
      if (this.history && this.history.length > 0) {
        return this.history.filter(change => change.type === 'comment')
      }
      return []
    }
  },
  watch: {
    openedTicket (val) {
      if (val) {
        this.dialog = true
        this.getTicketInfo()
      }
    },
    dialog (val) {
      if (!val) {
        this.$emit('close')
        this.$emit('updateList')
      }
    }
  },
  methods: {
    ...mapMutations(['SET_SNACKBAR']),
    ...mapActions(['copyToClipboard']),
    ticketStatusColor (status) {
      if (status === 'Finalizado') return 'success'
      if (status === 'Impedido') return 'error'
      if (status === 'Em andamento' || status === 'À fazer') return 'primary'
      return 'grey-4'
    },
    async getTicketInfo () {
      this.loading = true
      try {
        const response = await this.$store.dispatch('asanaApi', { method: 'GET', url: 'tasks/' + this.openedTicket })
        this.ticketInfo = response.data || {}
      } catch (error) {
        this.ticketInfo = {}
      }
      try {
        const response = await this.$store.dispatch('asanaApi', { method: 'GET', url: 'tasks/' + this.openedTicket + '/stories' })
        this.history = response.data || []
      } catch (error) {
        this.history = []
      }
      try {
        const response = await this.$store.dispatch('asanaApi', { method: 'GET', url: 'attachments/', params: { parent: this.openedTicket, opt_fields: 'download_url,name' } })
        console.log(response)
        this.files = response.data || []
      } catch (error) {
        this.files = []
      }
      // try {
      //   const response = await this.$store.dispatch('asanaApi', { method: 'GET', url: 'tasks/' + this.openedTicket })
      //   this.ticketInfo = response.data || {}
      // } catch (error) {
      //   this.ticketInfo = {}
      // }
      this.loading = false
    },
    donwloadBlob (fileURL) {
      this.donwloadingFile = fileURL
      this.$store.dispatch('clubhouseApi', { method: 'GET', url: fileURL, isBlob: true })
        .then((response) => {
          console.log(response)
        }).catch((e) => {
          this.SET_SNACKBAR({ text: 'Não foi possivel fazer o download do arquivo, tente novamente' })
          this.donwloadingFile = false
        })
    },
    ajustText (text) {
      let ajustedText = text || ''
      if (ajustedText) {
        // Image
        const imageRegex = /(!\[.*\))/g
        ajustedText = ajustedText.replace(imageRegex, (file) => {
          let fileUrl = file.split('(')[1]
          fileUrl = fileUrl && fileUrl.substring(0, fileUrl.length - 1)

          let fileName = file.split('[')[1]
          fileName = fileName && fileName.split(']')[0]

          if (fileUrl && fileName) {
            return '<a href="' + fileUrl + '" target="_blank" class="blue-grey darken-1 px-3 py-2" style="display:inline-block; border-radius:3px; color: white; text-decoration:none">' + fileName + '</a>'
          }
          return file
        })
        // URL
        const urlRegex = /(https?:\/\/[^\s]+)/g
        ajustedText = ajustedText.replace(urlRegex, (url) => {
          if (url.search('"') >= 0) return url
          return '<a href="' + url + '" target="_blank">' + url + '</a>'
        })
      }
      return ajustedText || '--Sem conteudo--'
    }
  }
}
</script>
